export default "__VITE_ASSET__55b4dded__"